
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member/forgot-password",
      function () {
        return require("private-next-pages/member/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member/forgot-password"])
      });
    }
  